import { AvatarMaskOverlay } from '@/components/AvatarMaskOverlay';
import { AvatarSilhouette } from '@/components/AvatarSilhouette';
import type { Audience, FitZoneState } from '@/types/domain';

interface Props {
  audience: Audience;
  /** Present once a valid comparison has run; undefined before that. */
  zones?: FitZoneState;
  /** 'small' is used for compact per-result thumbnails (see FitMatchCard) — same SVG, just a smaller frame. */
  size?: 'default' | 'small' | 'profile';
  /** Controlled by the parent (see the Front/Back toggle in EquivalentSizesPage) so avatar and toggle stay in sync. */
  view?: 'front' | 'back';
}

export function AvatarPanel({ audience, zones, size = 'default', view = 'front' }: Props) {
  const maxWidth = size === 'small' ? 'max-w-[84px]' : size === 'profile' ? 'max-w-[280px]' : 'max-w-[260px]';
  const rounding = size === 'small' ? 'rounded-xl' : 'rounded-2xl';
  return (
    <div className={`relative mx-auto aspect-[2/3] w-full ${maxWidth} overflow-hidden ${rounding} bg-gradient-to-b from-stone-50 to-stone-100`}>
      <AvatarSilhouette audience={audience} view={view} />
      {zones ? (
        <AvatarMaskOverlay audience={audience} zones={zones} />
      ) : (
        <p className="sr-only">No comparison has been run yet, so no fit shading is shown.</p>
      )}
    </div>
  );
}
